export enum ActionSize {
    Small,
    Medium,
    Large
}
